interface NameFields {
  firstName?: string;
  lastName?: string;
}

export interface NamedUser extends NameFields {
  profile?: NameFields | null;
}

const firstNonBlank = (...values: (string | undefined)[]): string =>
  values.find((value) => value?.trim()) ?? '';

export const getFirstName = (user: NamedUser | null | undefined): string =>
  firstNonBlank(user?.profile?.firstName, user?.firstName);

export const getLastName = (user: NamedUser | null | undefined): string =>
  firstNonBlank(user?.profile?.lastName, user?.lastName);
